export const Tag = ({size = 21, className = ''}) => {
  return (
    <i style={{width: size, height: size}} className={`flex justify-center items-center ${className}`}>
      <svg viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.3529 2.07387L39.7865 3.24416C41.3259 3.36898 42.5116 4.65471 42.5116 6.19918V20.2278C42.5116 20.752 42.3034 21.2547 41.9327 21.6254L20.9557 42.6024C20.1839 43.3743 18.9324 43.3743 18.1606 42.6024L2.39758 26.8394C1.62572 26.0676 1.62572 24.8161 2.39758 24.0443L23.7956 2.6463C24.2056 2.23629 24.7749 2.02701 25.3529 2.07387Z" stroke="currentColor" strokeWidth="3"/>
        <circle cx="28.8372" cy="16.1612" r="4.36047" stroke="currentColor" strokeWidth="3"/>
      </svg>

    </i>
  )
};
